/* unplugin-vue-components disabled */import { render } from "./TiDBAI.vue?vue&type=template&id=c8925ef8&scoped=true"
import script from "./TiDBAI.vue?vue&type=script&lang=js"
export * from "./TiDBAI.vue?vue&type=script&lang=js"

import "./TiDBAI.vue?vue&type=style&index=0&id=c8925ef8&lang=sass&scoped=true"

import exportComponent from "/app/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8925ef8"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
